import TableCell from "../TableCell";
import DetailRow from "../DetailRow";
import EditableTableCell from "../EditableTableCell";
import LabelWithInfoTooltip from "../Components/InfoToolTips";
import RefDataLabel from "../Components/RefDataLabel";

const CropEvent = ({ data ,idField , editFlag}) => {

  return (
    <>
      {/* {cropEventData.map((data, i) => ( */}
      <>
        <div className="fw-bold">Relative To Event:</div>

        <div className="table-responsive">
          <table class="table  mt-2  table-bordered mb-0">
            <thead>
              <tr className="table-light">
                {/* <th style={{ width: "30%" }} scope="col">
                  Internal Label
                </th> */}
                <th scope="col">Type</th>
                <th scope="col">Additional Fields</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {/* <td>
                  <TableCell
                    enableEdit={true}
                    editFlag={editFlag}
                    data={data.internalLabel}
                    idField={`${idField}.internalLabel["@none"]`}
                  />
                </td> */}
                <td>
                  <TableCell data={data.type}  idField={`${idField}.type`}/>
                </td>

                <td>
                  {data.insect && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Insect"
                          isRefData={true}
                        />}
                      data={data.insect.label["@none"]}
                      tooltipId={"cropevent-insect"}
                      tooltipInfo={"The insect pest associated with the event"}
                      idField={`${idField}.insect.label["@none"]`}
                    />
                  )}

                  {data.ploughedPriorToSowingPlanting && (
                    <>
                      <div>
                        <span className="fw-bold">
                          Ploughed Prior To Sowing Planting:
                        </span>
                        <LabelWithInfoTooltip
                          info={
                            "Flags whether the ground was ploughed prior to the crop being sown or planted out"
                          }
                          id={"ploughedPriorToSowingPlanting"}
                        />
                      </div>
                      <TableCell
                        //enableEdit={true}
                        // editFlag={editFlag}
                        data={data.ploughedPriorToSowingPlanting.toString()}
                         idField ={`${idField}.ploughedPriorToSowingPlanting`}
                      />
                    </>
                  )}

                  {data.crop && data.crop.label && (
                    <DetailRow 
                    label={
                      <RefDataLabel
                        label="Crop"
                        isRefData={true}
                      />
                    } data={data.crop.label["@none"]} tooltipId={"crop"} tooltipInfo={
                      "The crop with which the event is associated"
                    }
                    idField={`${idField}.crop.label["@none"]`}/>
                  )}
                   {data.crop && data.crop.growthStageDescription && (
                      <DetailRow
                        label={"Growth Stage Description"}
                        data={data.crop.growthStageDescription["@none"]}
                        idField={`${idField}.crop.growthStageDescription["@none"]`}
                      />
                    )}


                  {data.pest && data.pest.label && (
                    <DetailRow label={
                    <RefDataLabel
                          label="Pest"
                          isRefData={true}
                        />} data={data.pest.label["@none"]}  idField={`${idField}.pest.label["@none"]`} />
                  )}

                  {data.weed && (
                    <DetailRow label={<RefDataLabel
                          label="Weed"  
                          isRefData={true}
                        />} data={data.weed.label["@none"]}   idField={`${idField}.weed.label["@none"]`}/>
                  )}

                  {data.fungus && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Fungus"
                          isRefData={true}
                        />}
                      data={data.fungus.label["@none"]}
                      tooltipId={"cropevent-fungus"}
                      tooltipInfo={"The fungus species or species group to which the target applies"}
                      idField={`${idField}.fungus.label["@none"]`}
                    />
                  )}

                  {data.fungalLifecycleStage && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Fungal Life cycle Stage"
                          isRefData={true}
                        />}
                      data={data.fungalLifecycleStage.label["@none"]}
                      tooltipId={"fungalLifecycleStage"}
                      tooltipInfo={"The fungal lifecycle stage associated with the event"}
                      idField={`${idField}.fungalLifecycleStage.label["@none"]`}
                    />
                  )}

                  {data.cropGrowthStage && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Crop Growth Stage"
                          isRefData={true}
                        />}
                      data={data.cropGrowthStage.label["@none"]}
                      idField={`${idField}.cropGrowthStage.label["@none"]`}
                    />
                  )}
                  {data.pestDevelopmentStage && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Pest Development Stage"
                          isRefData={true}
                        />}
                      data={data.pestDevelopmentStage.label["@none"]}
                      idField={`${idField}.pestDevelopmentStage.label["@none"]`}
                    />
                  )}

                  {data.generalLifecycleStage &&
                    data.type === "GeneralLifecycleEvent" && (
                      <DetailRow
                        label={<RefDataLabel
                          label="General Life cycle Stage"
                          isRefData={true}
                        />}
                        data={data.generalLifecycleStage.label["@none"]}
                        tooltipId={"generalLifecycleStage"}
                        tooltipInfo={"The general agronomic lifecycle stage associated with the event"}
                        idField={`${idField}.generalLifecycleStage.label["@none"]`}
                      />
                    )}
                {data.generalLifecycleStage &&
                    data.type === "LifecycleEvent" && (
                      <DetailRow
                        label={<RefDataLabel
                          label="Life cycle Stage"
                          isRefData={true}
                        />}
                        data={data.generalLifecycleStage.label["@none"]}
                        idField={`${idField}.generalLifecycleStage.label["@none"]`}
                      />
                    )}

                  {data.pestLifecycleStage && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Pest Life cycle Stage"
                          isRefData={true}
                        />}
                      data={data.pestLifecycleStage.label["@none"]}
                      tooltipId={"pestLifecycleStage"}
                      tooltipInfo={"The insect lifecycle stage associated with the event"}
                      idField={`${idField}.pestLifecycleStage.label["@none"]`}
                    />
                  )}

                  {data.weedLifecycleStage && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Weed Life cycle Stage"
                          isRefData={true}
                        />}
                      data={data.weedLifecycleStage.label["@none"]}
                      tooltipId={"weedLifecycleStage"}
                      tooltipInfo={"The weed lifecycle stage associated with the event"}
                      idField={`${idField}.weedLifecycleStage.label["@none"]`}
                    />
                  )}

                  {data.weedGrowthStage && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Weed Growth Stage"
                          isRefData={true}
                        />}
                      data={data.weedGrowthStage.label["@none"]}
                      tooltipId={"weedGrowthStage"}
                      tooltipInfo={"The weed growth stage associated with the event"}
                      idField={`${idField}.weedGrowthStage.label["@none"]`}
                    />
                  )}

                  {data.growthStage && (
                    <DetailRow
                      label={
                        <RefDataLabel
                          label="Growth Stage"
                          isRefData={true}
                        />
                      }
                      data={data.growthStage.label["@none"]}
                      tooltipId={"growthStage"}
                      tooltipInfo={"The crop growth stage"}
                      idField={`${idField}.growthStage.label["@none"]`}
                    />
                  )}

                  {data.cropLifecycleStage && (
                    <DetailRow
                      label={<RefDataLabel
                          label="Crop Life cycle Stage"
                          isRefData={true}
                        />}
                      data={data.cropLifecycleStage.label["@none"]}
                      tooltipId={"cropLifecycleStage"}
                      tooltipInfo={"The crop lifecycle stage associated with the event"}
                      idField={`${idField}.cropLifecycleStage.label["@none"]`}
                    />
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
      {/* ))}*/}
    </>
  );
 
};

export default CropEvent;
